import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Shared app modal. Portals to document.body and reuses the proven
 * .modal-overlay + .task-modal CSS (App.css / TaskForm.css): centred on desktop,
 * a header-aware full-height scrolling sheet on mobile, and above the floating
 * Aidey chat launcher. Packaging only: pass the form as children, unchanged.
 *
 * Props:
 *   open            render nothing when false
 *   onClose         called on backdrop click when closeOnBackdrop is true
 *   ariaLabel       accessible dialog name
 *   maxWidth        desktop card width (mobile stays responsive via !important CSS)
 *   closeOnBackdrop close when the backdrop (not the card) is clicked
 *   children        the modal contents (e.g. a form)
 */
export default function AppModal({ open, onClose, ariaLabel, maxWidth, closeOnBackdrop = false, children }) {
  if (!open) return null;
  return createPortal(
    <div
      className="modal-overlay"
      onMouseDown={closeOnBackdrop ? (e) => { if (e.target === e.currentTarget) onClose?.(); } : undefined}
    >
      <div
        className="task-modal"
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        style={maxWidth ? { maxWidth } : undefined}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
